<ng-container *ngTemplateOutlet="data.content"></ng-container>
